// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"f4dc6837","38":"bf9cfcc0","89":"2caf6d63","249":"b7434698","254":"521f14e0","369":"3ad9c3be","425":"55b5fdbf","452":"30c9a462","464":"9ef24645","536":"4c3e566d","647":"eb862a60","667":"5bb2f958","690":"5c327840","693":"9210d776","709":"13e7c10c","964":"c14c35ea"}[chunkId] + ".chunk.js";
};